module.exports = __webpack_public_path__ + "static/media/Physiofit-14.01b85b58.jpg";